import { render, staticRenderFns } from "./actions_mobile.vue?vue&type=template&id=0bade71a&scoped=true&"
import script from "./actions_mobile.vue?vue&type=script&lang=js&"
export * from "./actions_mobile.vue?vue&type=script&lang=js&"
import style0 from "./actions_mobile.vue?vue&type=style&index=0&id=0bade71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bade71a",
  null
  
)

export default component.exports